import React, {useCallback} from 'react';
import cn from 'classnames';

import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';

import {ICarouselNavigationProps} from './ICarouselNavigation';

// eslint-disable-next-line no-restricted-imports
import './CarouselNavigation.scss';

const CarouselNavigation = ({swiperRef, currentConfig, classNames}: ICarouselNavigationProps) => {
	const handleSlidePrev = useCallback(() => {
		swiperRef.current.slidePrev();
	}, []);

	const handleSlideNext = useCallback(() => {
		swiperRef.current.slideNext();
	}, []);

	return (
		<div
			className={cn(
				'swiper-navigation',
				{
					'one-slide-row': currentConfig.slidesPerView === 1,
				},
				classNames.wrapper,
			)}
		>
			<Button
				onClick={handleSlidePrev}
				classNames={cn('swiper-navigation__btn', 'swiper-navigation__btn--prev', classNames.previousButton)}
			>
				<Icon
					name={currentConfig.navigationConfig?.prevBtnIcon || 'arrow-left'}
					title="prev"
					width={20}
					height={20}
				/>
			</Button>

			<Button
				onClick={handleSlideNext}
				classNames={cn('swiper-navigation__btn', 'swiper-navigation__btn--next', classNames.nextButton)}
			>
				<Icon
					name={currentConfig.navigationConfig?.nextBtnIcon || 'arrow-right'}
					title="next"
					width={20}
					height={20}
				/>
			</Button>
		</div>
	);
};

export default CarouselNavigation;
